import type { ElementDefinition } from './types';
import type { TemplateProfile } from '../templates';
import { insertExhibit } from '../word/exhibit';

/** Element definition for double exhibit insertion. */
export const doubleExhibitElement: ElementDefinition = {
  id: 'double-exhibit',
  label: 'Graph Double',
  icon: 'TableCellsSplitRegular',
  description: 'Double half-width exhibits',
  category: 'exhibit',
  async insertAsync(profile: TemplateProfile): Promise<void> {
    await insertExhibit('double', profile);
  },
};

/** Toolbar action for double exhibit insertion. */
export async function insertGraphDoubleLayout(profile: TemplateProfile): Promise<void> {
  await insertExhibit('double', profile);
}
